import { render, staticRenderFns } from "./DateTimeModal.vue?vue&type=template&id=70d20640&"
import script from "./DateTimeModal.vue?vue&type=script&lang=js&"
export * from "./DateTimeModal.vue?vue&type=script&lang=js&"
import style0 from "./DateTimeModal.vue?vue&type=style&index=0&id=70d20640&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports